import {
  ArrowRightLeft,
  ListChecks,
  MapPin,
  PackageMinus,
  Sparkles,
  Wrench,
  type LucideIcon,
} from "lucide-react";
import { cn } from "@/components/ui";

const TEMPLATE_ICON: Record<string, LucideIcon> = {
  "tpl-placement": MapPin,
  "tpl-relocation": ArrowRightLeft,
  "tpl-pickup": PackageMinus,
  "tpl-maintenance": Wrench,
  "tpl-custom": Sparkles,
};

const TEMPLATE_LABEL: Record<string, string> = {
  "tpl-placement": "Plaatsing",
  "tpl-relocation": "Verplaatsing",
  "tpl-pickup": "Ophaling",
  "tpl-maintenance": "Onderhoud",
  "tpl-custom": "Vrije taak",
};

export const TASK_TEMPLATE_OPTIONS: ReadonlyArray<{
  id: string;
  label: string;
}> = [
  { id: "tpl-placement", label: "Plaatsing" },
  { id: "tpl-relocation", label: "Verplaatsing" },
  { id: "tpl-pickup", label: "Ophaling" },
  { id: "tpl-maintenance", label: "Onderhoud" },
  { id: "tpl-custom", label: "Vrije taak" },
];

export function getTaskTemplateIcon(templateId: string | undefined): LucideIcon {
  if (!templateId) return ListChecks;
  return TEMPLATE_ICON[templateId] ?? ListChecks;
}

export function getTaskTemplateLabel(templateId: string | undefined): string {
  if (!templateId) return "Taak";
  return TEMPLATE_LABEL[templateId] ?? "Taak";
}

export function TaskTemplateIcon({
  templateId,
  className,
}: {
  templateId: string | undefined;
  className?: string;
}): React.JSX.Element {
  const Icon = getTaskTemplateIcon(templateId);
  return <Icon className={cn(className)} aria-hidden />;
}
